/**
 * The two receivables screens as tabs under one menu item (2026-09-14).
 *
 * Invoices starts from the invoice: what was issued and what is still owed.
 * Matching starts from the deposit: which invoices it pays. They answer
 * different questions, so they stay separate pages -- one list and one
 * workflow -- and share a place in the menu instead of taking two.
 *
 * Links, not buttons: each tab is its own address, so Back, a bookmark and the
 * links between the two screens all land on the right one.
 */

import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { to: '/invoices', label: 'Invoices' },
  { to: '/clearings', label: 'Matching' },
] as const;

export function ReceivablesTabs() {
  const { pathname } = useLocation();
  return (
    <nav className="row tabs" aria-label="Receivables">
      {TABS.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          className={`tab${pathname === tab.to ? ' is-current' : ''}`}
          aria-current={pathname === tab.to ? 'page' : undefined}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
